import { type AppThunk } from "../../../index";
import { getUserClaims } from "../../user/selectors";
import { fetchTeamMember } from "./fetchTeamMember";

/**
 * Re-reads the logged member without touching the realtime channel.
 *
 * Use this when a view only needs fresh data - coming back to a backgrounded tab, for
 * instance. Dispatching `subscribeToTeamMember` there tore the channel down and built a
 * new one on every tab switch, which is both wasteful and a source of join timeouts.
 */
export const refreshTeamMember = (): AppThunk => async (dispatch, getState) => {
  const { memberId } = getUserClaims(getState());

  if (memberId) {
    await dispatch(fetchTeamMember(memberId));
  }
};
